@if (reply) {
    <blockquote class="mb-1" (click)="viewReply()">
        <span class="truncate text-light">{{ reply.message.text || '...' | truncate: 20 }}</span>
        @if (reply.message.text && reply.message.text.length > 20) {
            <small>
                <a class="pointer ms-2 text-nowrap" translate>Show all</a>
            </small>
        }
    </blockquote>
}
